const INDIA_OFFSET_MINUTES = 330;

const parseDateParts = (value?: string): [number, number, number] | null => {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!match) return null;
  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const day = Number(match[3]);
  if (!Number.isInteger(year) || !Number.isInteger(monthIndex) || !Number.isInteger(day)) {
    return null;
  }
  return [year, monthIndex, day];
};

const toIstDayInstant = (value: string | undefined, endOfDay: boolean): string | undefined => {
  const parts = parseDateParts(value);
  if (!parts) return undefined;
  const [year, monthIndex, day] = parts;
  const utcMillis = endOfDay
    ? Date.UTC(year, monthIndex, day, 23, 59, 59, 999)
    : Date.UTC(year, monthIndex, day, 0, 0, 0, 0);
  const istMillis = utcMillis - (INDIA_OFFSET_MINUTES * 60 * 1000);
  return new Date(istMillis).toISOString();
};

export const toLocalDayStartInstant = (value?: string): string | undefined => toIstDayInstant(value, false);

export const toLocalDayEndInstant = (value?: string): string | undefined => toIstDayInstant(value, true);
